import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PopupSearch from "../components/PopupSearch";
import ScrollToTop from "../components/ScrollToTop";

const ShippingPolicy: React.FC = () => {
   const [menuOpen, setMenuOpen] =  useState(false);
  return (
    <>
      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />

      <main className="main">
        <Header />

        {/* Breadcrumb Section */}
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage: "url(assets/img/bg/breadcumb-bg-4.jpg)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <img
            src="assets/img/shapes/dot-shape.svg"
            alt="dot"
            className="breadcumb-element"
          />

          <div className="container z-index-common">
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">Shipping Policy</h1>

              <div className="breadcumb-menu-wrap">
                <ul className="breadcumb-menu">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>Shipping Policy</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Shipping Policy Content */}
        <section className="space-top space-extra-bottom">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="vs-blog blog-style1">
                  <div className="blog-content">
                    
                    <h3 className="blog-title">Order Processing</h3>
                    <p className="blog-text">
                      Orders are usually processed within 1-2 business days
                      after payment confirmation. During sale periods or
                      festivals, dispatch timelines may be slightly extended.
                    </p>

                    <h3 className="blog-title">Estimated Delivery</h3>
                    <ul className="list-style1">
                      <li>Metro cities: 2-4 business days</li>
                      <li>Other cities/towns: 4-7 business days</li>
                      <li>Remote locations: 7-10 business days</li>
                    </ul>

                    <h3 className="blog-title">Shipping Charges</h3>
                    <p className="blog-text">
                      Standard shipping is free on eligible prepaid orders. Any
                      special shipping fee, if applicable, is shown at checkout
                      before order confirmation.
                    </p>

                    <h3 className="blog-title">Order Tracking</h3>
                    <p className="blog-text">
                      Once your order is shipped, tracking details are shared
                      via SMS/email. You can also check updates from your
                      account or contact our support team.
                    </p>

                    <h3 className="blog-title">Delivery Attempts</h3>
                    <p className="blog-text">
                      Our courier partners typically attempt delivery up to 2-3
                      times. If the order is undelivered due to incorrect
                      address or unavailability, it may be returned to origin.
                    </p>

                    <h3 className="blog-title">Need Help?</h3>
                    <p className="blog-text">
                      For delivery issues or shipping support, contact{" "}
                      <a href="mailto:Ninesisters0819@gmail.com">
                        Ninesisters0819@gmail.com
                      </a>{" "}
                      or call{" "}
                      <a href="tel:+918928218258">
                        (+91) 89282 18258
                      </a>
                      .
                    </p>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>

      <ScrollToTop />
    </>
  );
};

export default ShippingPolicy;